import React, { createContext } from 'react';

import { useTransactionFilter } from '..';
import { TransactionFilterFormType } from '../transactionFilterTypes';

export const TransactionFilterContext = createContext<TransactionFilterFormType | undefined>(undefined);

export const useTransactionFilterContext = () => {
    const context = React.useContext(TransactionFilterContext);
    if (context === undefined) {
        throw new Error('useTransactionFilterContext must be used within a TransactionFilterProvider');
    }
    return context;
};

type Props = object;

export const TransactionFilterProvider: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
    const value = useTransactionFilter();
    return <TransactionFilterContext.Provider value={value}>{children}</TransactionFilterContext.Provider>;
};
